// extracted by mini-css-extract-plugin
export var container = "_4l-0";
export var icon = "_4l-1";
export var text = "_4l-2";